import { render } from "./ShopProduct.vue?vue&type=template&id=0ef29dde"
import script from "./ShopProduct.vue?vue&type=script&lang=js"
export * from "./ShopProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__